module.exports = __webpack_public_path__ + "static/media/laugh-squint.3f22f46c.svg";